import { Box, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import parse from 'html-react-parser';
import Image from 'next/image';
import type { FC } from 'react';
import styled from 'styled-components';
import { ImpactItemDescriptionText, type ImpactItemProps } from './OurCommunityImpact';
import {
  ImpactItem,
  ImpactItemDescription,
  ImpactItemImpactTitle,
  ImpactItemInfo,
  ImpactItemTitle,
} from './StyledElements';

const ImpactItemTitleText = styled.h3`
  text-wrap: balance;
  ${font('main', {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    fontWeight: 'bold',
  })}

  ${MEDIA_QUERIES.tabletAndDesktop`
    text-align: center;
  `}
`;

const ImpactItemImpactText = styled.h4`
  color: ${themedColor('primary')};
  ${font('main', {
    fontSize: '2.0rem',
    lineHeight: '2.9rem',
    fontWeight: 'bold',
  })}
  ${MEDIA_QUERIES.tabletAndDesktop`
    text-align: center;
    ${font('main', {
      fontSize: '2.4rem',
      lineHeight: '145%',
      fontWeight: 'bold',
    })}
  `};
`;

export const ImpactIconItem: FC<ImpactItemProps> = ({ title, impact, desc, image, imageMobile }) => {
  return (
    <ImpactItem
      key={title}
      flexDirection={['row', 'column']}
      alignItems="center"
      position="relative"
      flexBasis={[0, 270]}
      minWidth={[210, 270]}
      mx={[0, 30]}
      mb={[40, 0]}
      role="listitem"
    >
      <Box display={['block', 'none']}>
        <Image alt={title} src={imageMobile} tabIndex={-1} />
      </Box>
      <Box display={['none', 'block']}>
        <Image alt={title} src={image} tabIndex={-1} />
      </Box>
      <ImpactItemInfo pl={[12, 0]} tabIndex={0}>
        <ImpactItemTitle flexDirection="column" alignItems={['flex-start', 'center']}>
          <ImpactItemTitleText key={title}>{parse(title)}</ImpactItemTitleText>
        </ImpactItemTitle>
        <ImpactItemImpactTitle flexDirection="column" alignItems={['flex-start', 'center']}>
          <ImpactItemImpactText>{impact}</ImpactItemImpactText>
        </ImpactItemImpactTitle>
        <ImpactItemDescription flexDirection="column" alignItems={['flex-start', 'center']}>
          <ImpactItemDescriptionText key={desc} style={{ whiteSpace: 'pre-line' }}>
            {parse(desc)}
          </ImpactItemDescriptionText>
        </ImpactItemDescription>
      </ImpactItemInfo>
    </ImpactItem>
  );
};
